import { useCallback } from 'react';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';
import { usePost, UsePostParams } from '../../../../api';

export interface UnbindLocalAccountsPayload {
    localAccountGuids: string[];
}

export type UnbindLocalAccountsResponse = never;
export type UnbindLocalAccountsError = unknown;

export type UseUnbindLocalAccountsParams = UsePostParams<
    UnbindLocalAccountsPayload,
    UnbindLocalAccountsResponse,
    UnbindLocalAccountsError
>;

export const useUnbindLocalAccounts = (params: UseUnbindLocalAccountsParams = {}) => {
    const { post, ...rest } = usePost<
        UnbindLocalAccountsPayload,
        UnbindLocalAccountsResponse,
        UnbindLocalAccountsError
    >(params);

    const unbindLocalAccounts = useCallback(
        (localAccountGuids: string[]) =>
            post(`${LOCAL_ACCOUNTS_BASE_URL}/unbind`, {
                localAccountGuids
            }),
        [post]
    );

    return {
        ...rest,
        unbindLocalAccounts
    };
};

export default useUnbindLocalAccounts;
